import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiFetch } from "../config/api";
import { clearSession, getUser } from "../config/auth";
import { SUITE_APPS } from "../config/suiteApps";

function AppIcon({ d, disabled }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke={disabled ? "#94a3b8" : "#fff"}
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      width={26}
      height={26}
      aria-hidden="true"
    >
      <path d={d} />
    </svg>
  );
}

export default function AppSelectionPage() {
  const navigate = useNavigate();
  const user = getUser();
  const [enabledModules, setEnabledModules] = useState(null);

  useEffect(() => {
    apiFetch("/api/modules")
      .then((r) => (r.ok ? r.json() : []))
      .then((data) => {
        if (!Array.isArray(data)) return;
        setEnabledModules(
          new Set(data.filter((m) => m.isEnabled).map((m) => m.moduleKey))
        );
      })
      .catch(() => {});
  }, []);

  function signOut() {
    clearSession();
    navigate("/login", { replace: true });
  }

  function openApp(app) {
    if (!app.implemented) return;
    if (enabledModules && !enabledModules.has(app.moduleKey)) return;
    navigate(app.path);
  }

  return (
    <main className="app-select-page">
      <div className="app-select-shell">
        <header className="app-select-header">
          <div className="app-select-brand">
            <img src="/logo.svg" alt="Tackl" className="app-select-logo" />
            <div>
              <div className="app-select-wordmark">Tackl Suite</div>
              <div className="app-select-workspace">
                {user?.tenantName || user?.tenantSlug || "Default Workspace"}
              </div>
            </div>
          </div>

          <div className="app-select-user">
            <div className="app-select-user-meta">
              <span>{user?.name || user?.email || "User"}</span>
              <small>{user?.role || "User"}</small>
            </div>
            <button
              type="button"
              className="app-select-signout"
              onClick={signOut}
            >
              Sign out
            </button>
          </div>
        </header>

        <section className="app-select-main">
          <div className="app-select-title">
            <span>Workspace</span>
            <h1>Select tool</h1>
          </div>

          <div className="app-select-grid">
            {SUITE_APPS.filter((app) => !app.hidden).map((app) => {
              const moduleDisabled =
                enabledModules ? !enabledModules.has(app.moduleKey) : false;
              const comingSoon = !app.implemented;
              const disabled = comingSoon || moduleDisabled;

              return (
                <button
                  key={app.moduleKey}
                  type="button"
                  className={`app-select-card${disabled ? " app-select-card--disabled" : ""}`}
                  disabled={disabled}
                  onClick={() => openApp(app)}
                  style={{
                    "--app-color": app.color,
                    "--app-soft": app.softColor,
                  }}
                >
                  <div className="app-select-card-top">
                    <span
                      className="app-select-card-icon"
                      style={
                        disabled
                          ? { background: "var(--surface-2)", border: "1px solid var(--border)" }
                          : {}
                      }
                    >
                      <AppIcon d={app.icon} disabled={disabled} />
                    </span>
                    {comingSoon && (
                      <span className="app-select-card-soon">Soon</span>
                    )}
                    {!comingSoon && moduleDisabled && (
                      <span className="app-select-card-soon">Disabled</span>
                    )}
                  </div>

                  <div className="app-select-card-body">
                    <span className="app-select-card-label">{app.label}</span>
                    <span className="app-select-card-desc">
                      {app.description}
                    </span>
                  </div>

                  <span className="app-select-card-status">
                    {comingSoon
                      ? "Coming soon"
                      : moduleDisabled
                      ? "Disabled"
                      : "Open →"}
                  </span>
                </button>
              );
            })}
          </div>
        </section>
      </div>
    </main>
  );
}
